import { useState, FC, createContext, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export const RouteContext = createContext({
  to: '',
  from: '',
});
export const useRoute = (): {
  to: string;
  from: string;
} => useContext(RouteContext);

export const RouteProvider: FC = ({ children }) => {
  const location = useLocation();
  const [route, setRoute] = useState({
    to: '',
    from: '',
  });

  useEffect(() => {
    setRoute(prev => ({ to: location.pathname, from: prev.to }));
  }, [location]);

  return <RouteContext.Provider value={route}>{children}</RouteContext.Provider>;
};
